import {registerGraphNode} from "#graph/decorators/register-node"
import {fixedValueNodeDefinition} from "#graph/nodes/fixed-value/definition"
import {GraphNode} from "#graph/nodes/graph/graph-node"
import {z} from "zod/v4-mini"

@registerGraphNode
export class FixedValue<ValueType, Context> extends GraphNode<ValueType, Context, {value: ValueType}> {
    public override get definition() {
        return fixedValueNodeDefinition("FixedValue", z.any())
    }

    override run = async (): Promise<ValueType> => {
        return this.parameters.value
    }

    override runSync = (): ValueType => {
        return this.parameters.value
    }
}

@registerGraphNode
export class NumberValue<Context = unknown> extends FixedValue<number, Context> {
    public override get definition() {
        return fixedValueNodeDefinition("NumberValue", z.number())
    }
}

@registerGraphNode
export class StringValue<Context = unknown> extends FixedValue<string, Context> {
    public override get definition() {
        return fixedValueNodeDefinition("StringValue", z.string())
    }
}

@registerGraphNode
export class MixedOutput<Context = unknown> extends FixedValue<{a: number; b: string}, Context> {
    public override get definition() {
        return fixedValueNodeDefinition("MixedOutput", z.object({a: z.number(), b: z.string()}))
    }
}
